import { IMatSelectOption } from "../../interface/common.interface";

export enum ClaimStatus {
  New = "New",
  Processing = "Processing",
  Approved = "Approved",
  Rejected = "Rejected"
}

export const CLAIM_STATUS_LABEL_MAP = {
  [ClaimStatus.New]: "New",
  [ClaimStatus.Processing]: "Processing",
  [ClaimStatus.Approved]: "Approved",
  [ClaimStatus.Rejected]: "Rejected"
};

export function getClaimStatusLabel(claimStatus: string): string {
  return CLAIM_STATUS_LABEL_MAP[claimStatus] || "";
}

export function getClaimStatusList(): string[] {
  return Object.keys(CLAIM_STATUS_LABEL_MAP);
}

/**
 * Ops can only update claim status IN ('New', 'Processing')
 * NEW -> PROCESSING
 * PROCESSING -> APPROVED || REJECTED
 * */
export function getClaimStatusOptions(
  claimStatus: ClaimStatus
): IMatSelectOption[] {
  const claimStatusMap = {
    [ClaimStatus.New]: [
      {
        id: ClaimStatus.Processing,
        label: CLAIM_STATUS_LABEL_MAP[ClaimStatus.Processing]
      }
    ],
    [ClaimStatus.Processing]: [
      {
        id: ClaimStatus.Approved,
        label: CLAIM_STATUS_LABEL_MAP[ClaimStatus.Approved]
      },
      {
        id: ClaimStatus.Rejected,
        label: CLAIM_STATUS_LABEL_MAP[ClaimStatus.Rejected]
      }
    ]
  };

  return claimStatusMap[claimStatus] || [];
}